export const authKeys = {
  providers: () => ['auth', 'providers'] as const,
  invitation: (token: string) => ['auth', 'invitation', token] as const,
  twoFactor: () => ['auth', 'two-factor'] as const,
  /** The same key the organisation-settings feature uses, so one fetch serves both screens. */
  organizationTwoFactorRule: () => ['org', 'settings'] as const,
};
